import moment from 'moment';
import { LanguageProvider } from '../../../core/language-provider';
import { formatItalianNumber } from './engine';

/**
 * Tag disponibili per template: template_invoice_acc_customer
 *
 * TESTATA:
 *   {internalCode}          - Codice interno fattura
 *   {date}                  - Data fattura (DD/MM/YYYY)
 *   {nameCustomer}          - Nome cliente
 *   {addressCustomer}       - Indirizzo cliente
 *   {vatNumberCustomer}     - P.IVA cliente
 *   {deliveryAddressName}   - Nome indirizzo consegna
 *   {deliveryAddressOffice} - Indirizzo sede consegna
 *   {deliveryPhone}         - Telefono consegna
 *   {deliveryEmail}         - Email consegna
 *   {paymentCondition}      - Condizione di pagamento
 *   {bankCustomer}          - Banca cliente
 *   {notesInternal}         - Note interne
 *   {notesInvoice}          - Note fattura
 *
 * RIGHE (loop {#rows}...{/rows}):
 *   {code}           - Codice articolo
 *   {description}    - Descrizione
 *   {externalCode}   - Codice esterno ordine
 *   {orderNumber}    - Numero ordine
 *   {um}             - Unita di misura
 *   {quantity}       - Quantita
 *   {price}          - Prezzo unitario
 *   {discount}       - Sconto
 *   {total}          - Totale riga
 *   {vatPercentage}  - Percentuale IVA
 *
 * TRASPORTO/SPEDIZIONE:
 *   {vatException}       - Esenzione IVA
 *   {costSpedizione}     - Costo spedizione
 *   {vatSpedizione}      - IVA spedizione
 *   {costIncasso}        - Costo incasso
 *   {vatIncasso}         - IVA incasso
 *   {tablePayments}      - Tabella pagamenti
 *   {installmentsPayments} - Rate pagamenti
 *   {typePayments}       - Tipo pagamenti
 *   {totalPayments}      - Totale pagamenti
 *   {packagesQuantity}   - Numero colli
 *   {weight}             - Peso
 *   {volume}             - Volume
 *   {totalImponibile}    - Totale imponibile
 *   {totalIva}           - Totale IVA
 *   {totalPrice}         - Totale fattura
 *   {transportBy}        - Trasporto a cura di
 *   {nameForwarder}      - Nome corriere
 *   {transportDate}      - Data trasporto
 *   {incoterms}          - Incoterms
 *   {itemsAspect}        - Aspetto dei beni
 *   {transportReason}    - Causale trasporto
 *
 * Extra args: order, rows, paymentConditionName
 */

export default {
    tags: {
        internalCode: 'internalCode',
        date: { path: 'date', format: 'date' },
        nameCustomer: 'nameCustomer',
        addressCustomer: 'addressCustomer',
        vatNumberCustomer: 'vatNumberCustomer',
        deliveryAddressOffice: 'addressCustomerOffice',
        tablePayments: 'tablePayments',
        installmentsPayments: 'installmentsPayments',
        typePayments: 'typePayments',
        totalPayments: 'totalPayments',
        packagesQuantity: 'packagesQuantity',
        weight: 'weight',
        volume: 'volume',
        totalImponibile: 'totalImponibile',
        nameForwarder: 'nameForwarder',
        transportReason: 'transportReason',
    },

    computed: (invoice, order, rows, paymentConditionName) => {
        const resolveObjValue = (v) => {
            if (!v) return '';
            if (typeof v === 'object') return v.label || v.name || '';
            return v;
        };

        return {
            deliveryAddressName: order?.address?.name || '',
            deliveryPhone: order?.address?.phone || '',
            deliveryEmail: order?.address?.email || '',
            paymentCondition: paymentConditionName || resolveObjValue(invoice.paymentConditionCustomer),
            bankCustomer: resolveObjValue(invoice.bankCustomer),
            notesInternal: order?.notesInternal || '',
            notesInvoice: order?.notesInvoice || '',
            rows: (rows || []).map(row => ({
                code: row.idItemModel?.code || '',
                description: row.name || '',
                externalCode: row.idCustomerOrder?.externalCode || order?.externalCode || '',
                orderNumber: row.idCustomerOrder?.internalCode || order?.internalCode || '',
                um: resolveObjValue(row.measureUnit),
                quantity: row.quantity || '',
                price: row.price != null ? formatItalianNumber(row.price, 2) + ' €' : '',
                discount: row.discountItemModel ? row.discountItemModel + '%' : '',
                total: formatItalianNumber(row.totalRow || 0, 2) + ' €',
                vatPercentage: row.idVatCondition?.percentage != null ? row.idVatCondition.percentage + '%' : '',
            })),
            vatException: order?.idVatCondition?.percentage !== "0" ? '' : (order?.idVatCondition?.name || ''),
            costSpedizione: formatItalianNumber(order?.costSpedizione || 0, 2) + ' €',
            vatSpedizione: formatItalianNumber((order?.totalSpedizione || 0) - (order?.costSpedizione || 0), 2) + ' €',
            costIncasso: formatItalianNumber(order?.costIncasso || 0, 2) + ' €',
            vatIncasso: formatItalianNumber((order?.totalIncassoIva || 0) - (order?.totalIncasso || 0), 2) + ' €',
            totalIva: formatItalianNumber(invoice.totalIva || 0, 2) + ' €',
            totalPrice: formatItalianNumber(invoice.totalPrice || 0, 2) + ' €',
            transportBy: invoice.transportBy?.value ? LanguageProvider.getLabel('customer_invoices', 'transportBy.options.' + invoice.transportBy.value) : '',
            transportDate: invoice.date ? moment(invoice.date).format('DD/MM/YYYY') : '',
            incoterms: invoice.incotermsCustomer || '',
            itemsAspect: invoice.itemsAspect?.value ? LanguageProvider.getLabel('customer_invoices', 'itemsAspect.options.' + invoice.itemsAspect.value) : '',
        };
    }
};
